import { render, staticRenderFns } from "./cgv-page.vue?vue&type=template&id=a2180dde&scoped=true&"
var script = {}
import style0 from "./cgv-page.vue?vue&type=style&index=0&id=a2180dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2180dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevinmathieu/crr-sl-fr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2180dde')) {
      api.createRecord('a2180dde', component.options)
    } else {
      api.reload('a2180dde', component.options)
    }
    module.hot.accept("./cgv-page.vue?vue&type=template&id=a2180dde&scoped=true&", function () {
      api.rerender('a2180dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/fo/pages/cgv-page/cgv-page.vue"
export default component.exports